import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box, Typography } from "@mui/material";

import msfActions from "../../../../actions/msfActions";
import { getSurveyReport } from "../../../../reducers";


const ReportSummary = ({surveyId, canFetch}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!canFetch) {
            dispatch(msfActions.getSurveyReport("P-MSF", surveyId))
        }
    }, [dispatch, surveyId, canFetch]);

    const report = useSelector((state) => getSurveyReport(state, surveyId)) || {};

    return (
        <Box className="card-content">
            {!report.summary?.segments?.length
                ? (
                    <div className="medial-preview-unavailable">
                        <Typography component="span" variant="body2" color="textPrimary" >
                            No preview available
                        </Typography>
                    </div>
                )
                : report.summary.segments.map(({title, description, questions}) => ([
                    <Typography variant="h4" component="h3" mb={1}>{title}</Typography>,
                    <Typography>{description}</Typography>,
                    questions.map((question) => ([
                        <Typography component="h4" mb={1}>{question.title}</Typography>,
                        <Typography>
                            {question.results.map(({label, total}) => (
                                `${label}: ${total} `
                            ))}
                        </Typography>,
                        !!question.hasOwnProperty('assessor_avg') && !!question.hasOwnProperty('self_score') && (
                            <Typography mb={3}>
                                {`Average: ${question.assessor_avg} Self score: ${question.self_score}`}
                            </Typography>
                        )
                    ]))
                ]))
            }

        </Box>
    );
};

export default ReportSummary;
